import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { MailrailBaseEmailCampaign } from '@feathr/blackbox';
import { Form } from '@feathr/components';

import MailrailTestSendForm from '../MailrailTestSendForm';

interface IProps {
  campaign: MailrailBaseEmailCampaign;
  disabled?: boolean;
}

/**
 * The wizard "Test" step for Mailrail campaigns. It frames the shared {@link MailrailTestSendForm}
 * (which owns the recipient/email inputs, validation, and save-less send) with the wizard's form
 * chrome. The campaign IS the mailing here, so no `mailing_id` is sent.
 */
function MailrailCampaignStepTest({ campaign, disabled = false }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <Form
      description={t(
        'Feathr recommends that you use this step to confirm that your email campaign works and looks as expected. Provide a list of email addresses below and select Submit to send a test email to the provided recipients using your chosen email template.',
      )}
      label={t('Edit Campaign: Test')}
    >
      <MailrailTestSendForm campaign={campaign} disabled={disabled} mailing={campaign} />
    </Form>
  );
}

export default observer(MailrailCampaignStepTest);
